import comp from "./AssessmentLearningGoalsSearchInput";
export default comp;
